export default __webpack_public_path__ + "static/media/logo-dark.7fd101e9.png";